import type { NavigateFunction } from 'react-router-dom'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import type { UserAccountData } from '@/firebase/auth/user-account-data'

export const kPostSignupPhonePath = '/complete-signup/phone'

export type PostSignupPhoneLocationState = {
  startPostSignupPhone: true
}

export function isPostSignupPhoneEnrollment(state: unknown): state is PostSignupPhoneLocationState {
  return typeof state === 'object' && state !== null && 'startPostSignupPhone' in state && state.startPostSignupPhone === true
}

export function continueAfterEmailPasswordSignup(navigate: NavigateFunction): void {
  if (kGetFeatureFlagStatus(kFeatureFlags.POST_SIGNUP_PHONE_COLLECTION)) {
    navigate(kPostSignupPhonePath, { state: { startPostSignupPhone: true } satisfies PostSignupPhoneLocationState })
    return
  }

  navigate('/dashboard')
}

export function isPostSignupPhoneEligible(userAccountData: UserAccountData): boolean {
  return !userAccountData.isAnonymous && !userAccountData.isOrgAccount
}
